<template>
  <main class="grc-home">
    <header class="hero">
      <p class="eyebrow">GRC</p>
      <h1>Home de Governança, Riscos e Compliance</h1>
      <p class="description">
        Acesso central às trilhas operacionais do módulo GRC.
      </p>
    </header>

    <section class="grid">
      <article v-for="card in cards" :key="card.id" class="card">
        <h2>{{ card.title }}</h2>
        <p>{{ card.description }}</p>
        <router-link class="card-link" :to="card.to">
          {{ card.cta }}
        </router-link>
      </article>
    </section>

    <footer class="actions">
      <router-link class="link" :to="`/${company}`">Voltar para home da empresa</router-link>
    </footer>
  </main>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';


const route = useRoute();

const normalizeSlug = (value) => (value || '')
  .toString()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '');

const company = computed(() => normalizeSlug(route.params.company) || 'due');

const cards = computed(() => [
  {
    id: 'denuncias',
    title: 'Canal de denúncias',
    description: 'Acesse o painel do canal de denúncias e fluxos relacionados.',
    cta: 'Abrir denúncias',
    to: `/${company.value}/denuncias`,
  },
  {
    id: 'gestao-denuncias',
    title: 'Gestão de denúncias',
    description: 'Acompanhe denúncias recebidas, indicadores e planos de ação.',
    cta: 'Abrir gestão',
    to: `/${company.value}/denuncias/gestao`,
  },
  {
    id: 'riscos',
    title: 'Gestão de riscos',
    description: 'Acesse matriz, regras de impacto, fluxogramas e controles internos.',
    cta: 'Abrir riscos',
    to: `/${company.value}/gestao-de-riscos`,
  },
  {
    id: 'normativos',
    title: 'Normativos e compliance',
    description: 'Gerencie normativos, código de conduta e política de integridade.',
    cta: 'Abrir normativos',
    to: `/${company.value}/normativos`,
  },
  {
    id: 'treinamentos',
    title: 'Treinamentos',
    description: 'Gerencie trilhas, cadastros e indicadores de treinamentos.',
    cta: 'Abrir treinamentos',
    to: `/${company.value}/treinamentos`,
  },
  {
    id: 'terceiros',
    title: 'Terceiros',
    description: 'Acesse o fluxo de due diligence e gestão de terceiros.',
    cta: 'Abrir terceiros',
    to: `/${company.value}/terceiros`,
  },
]);
</script>

<style scoped>
.grc-home {
  max-width: 1024px;
  margin: 0 auto;
  padding: 32px 20px 48px;
  color: #0f172a;
}

.hero {
  margin-bottom: 24px;
}

.eyebrow {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0369a1;
}

h1 {
  margin: 0 0 8px;
  font-size: 32px;
  line-height: 1.2;
}

.description {
  margin: 0;
  font-size: 16px;
  color: #334155;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
  margin-bottom: 28px;
}

.card {
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 16px;
  background: #f8fafc;
}

.card h2 {
  margin: 0 0 8px;
  font-size: 18px;
}

.card p {
  margin: 0 0 12px;
  color: #334155;
}

.card-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #0f172a;
  border-radius: 8px;
  padding: 8px 12px;
  text-decoration: none;
  color: #0f172a;
  font-weight: 600;
  background: #ffffff;
}

.card-link:hover {
  background: #f1f5f9;
}

.actions {
  display: flex;
  gap: 12px;
}

.link {
  color: #0369a1;
  font-weight: 600;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}
</style>
